export const tags = {
  BeefAndBison: 1,
  Poultry: 2,
  Pork: 3,
  FreshFish: 4,
  Shellfish: 5,
  SmokedFish: 6,
  TofuAndTempeh: 7,
  BeansAndLentils: 9,
  MeatAlternatives: 10,
  DairyFreeCheese: 12,
  supplements: 14,
  Lamb: 16,
  CarbConscious: 23,
  LessSugar: 24,
  HighProtein: 25,
  LowSodium: 26,
  breakfast: 47,
  lunch: 48,
  NonGMO: 49,
  Creamy: 50,
  Cheesy: 51,
  Herbs: 53,
  Umami: 54,
  Sweet: 55,
  Spiced: 56,
  Onions: 61,
  Garlic: 62,
  Mushrooms: 64,
  LowCalorie: 65,
  Indian: 78,
  Mediterranean: 79,
  Mexican: 80,
  American: 81,
  Italian: 82,
  Spicy: 83,
  Thai: 84,
  Chinese: 85,
  Japanese: 86,
  Korean: 87,
  PreCookedProteins: 130,
  PreCutProduce: 131,
  Smoky: 134,
  Fusion: 136,
  Grill: 151,
  Airfryer: 152,
  Microwave: 153,
  Blender: 154,
  Crockpot: 155,
  Stove: 156,
  Cilantro: 165,
  BellPeppers: 166,
  Tomatoes: 167,
  Eggplants: 168,
  Potatoes: 169,
  NoSugar: 186,
  TwentyMinutesOrLess: 189,
  NoRefrigeration: 199,
  Oven: 207,
  Burritos: 234,
  Tamales: 235,
  Salads: 236, // Ready Made
  Sandwiches: 237, // Ready Made
  Pizza: 238, // Ready Made
  Trays: 239,
  Bowls: 240, // Ready Made
  Soups: 241,
  AntiInflamitory: 242,
  GutFriendly: 243,
  ImmunityBoosting: 244,
  DinnerMainsAndSides: 345,
  DinnerBowls: 346,
  DinnerPastas: 347,
  DinnerTacos: 348,
  DinnerStirFries: 350,
  DinnerKids: 351,
  FamilyMeals: 352,
  DinnerSalads: 353,
  DinnerWraps: 354,
  DinnerSandwiches: 355,
  DinnerBurgers: 356,
  DinnerBakes: 357,
  DinnerPizzas: 358,
  DinnerSoupsAndStews: 359,
  HeatAndEat: 379,
  LunchMainsAndSides: 382,
  LunchGrainBowls: 383,
  LunchPastas: 384,
  LunchTacos: 385,
  LunchStirFries: 387,
  LunchSalads: 390,
  LunchWraps: 391,
  LunchSandwiches: 392,
  LunchBurgers: 393,
  LunchPizzas: 395,
  LunchSoups: 396,
  Cals500To650: 660,
  NoSeedOils: 665,
  LowFodmap: 666,
  // These cholesterol values are for the food property.
  LowCholesterol: 749, // Less Cholesterol
  HighFiber: 750, // More fiber
  LowFat: 751, // Less Fat
  Garlicky: 777,
  Tangy: 778,
  Peppery: 779,
  Hearty: 780,
  CalorieConscious: 791,
  Beets: 792,
  Coconut: 793,
  Bison: 794,
  Steak: 795,
  Tuna: 796,
  Trout: 797,
  Whitefish: 798,
  Salmon: 801,
  GroundBeef: 802,
  Turkey: 803,
  Chicken: 804,
  WildCaughtSeafood: 806,
  ChefStyleRecipes: 809,
  ReadyToEat: 810,
  QuickRecipes: 817,
  EasyPrepSalads: 5590,
  OvenReadyEntrees: 5591,
  OrganicProduce: 814,
  GrassFedMeat: 815,
  OnlyLowSodium: 900,
  BrusselSprouts: 1150,
  Paneer: 1151,
  ChiliPeppers: 1152,
  SoySauce: 1153,
  Miso: 1154,
  MasalaSpices: 1155,
  // Tag group 75 - "Primary" protein tags. Use these for filtering Shop
  // results where the primary protein is the specified type. See WEB-7140.
  ChickenPrimary: 4646,
  TurkeyPrimary: 4647,
  GroundBeefPrimary: 4648,
  PorkPrimary: 4649,
  BisonPrimary: 4650,
  LambPrimary: 4651,
  WhitefishPrimary: 4652,
  TunaPrimary: 4653,
  SalmonPrimary: 4654,
  TroutPrimary: 4655,
  SteakPrimary: 4775,
  ShellfishPrimary: 4776,
  SmokedSalmonPrimary: 4777,
  BeansAndLentilsPrimary: 4778,
  TofuAndTempehPrimary: 4779,
  MeatAlternativesPrimary: 4780,
  LoseWeight: 4563,
  LowerBloodPressure: 4564,
  ManageBloodSugar: 4565,
  SupportGutHealth: 4566,
  ReduceInflammation: 4567,
  SupportGLP1: 4568,
  IncreaseEnergy: 4569,
  StrengthenImmunity: 4570,
  SupportJointAndMuscleRecovery: 4571,
  SupportThyroidHealth: 4572,
  PerimenopauseOrMenopause: 4573,
  SupportPregnancyOrPostpartum: 4574,
  // This LowerCholesterol value is for the health goal property.
  LowerCholesterol: 4575,
  IncreaseStrength: 4576,
  // "BFL L1 - Seafood" — used to identify seafood products.
  SeafoodBflL1: 3393,
  // "BFL L1 - {Beef,Bison,Lamb,Pork,Poultry}" — used to identify meat products.
  BeefBflL1: 3388,
  BisonBflL1: 3389,
  LambBflL1: 3390,
  PorkBflL1: 3391,
  PoultryBflL1: 3392,
  // Shortened food-formats screen — groceries/basics tile.
  GroceriesAndMore: 5495,
} as const;

export type Tags = (typeof tags)[keyof typeof tags];
